export default __webpack_public_path__ + "static/media/ico-edit-white.0c9197fc.svg";